import { actionCreator, BASE_URL } from "../../shared/utility";
import { ClientLogAction } from "../consts/index";

export function fetchClientLogDetails(payload) {
    return(dispatch, getState) => {
        const token = getState().AuthReducer.authResponse.authtoken
        dispatch(actionCreator(ClientLogAction.fetchClientLogDetails.REQUEST))
        fetch(`${BASE_URL}/mst/api/data/web/getClientLogMapping`, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(response => {
            if(!response.st) {
                if(response.responseCode && response.responseCode === "401") {
                    localStorage.setItem("tokenExpired", "true")
                    localStorage.removeItem('accessToken')
                    window.location.reload()
                }  else {
                    dispatch(actionCreator(ClientLogAction.fetchClientLogDetails.FAILURE, response))
                }
            } else {
                dispatch(actionCreator(ClientLogAction.fetchClientLogDetails.SUCCESS, response))
            }
        })
        .catch((error) => {
            console.log("error >>> ", error)
        })
    }
}

export function fetchDirectoryPath(payload) {
    return(dispatch, getState) => {
        const token = getState().AuthReducer.authResponse.authtoken
        dispatch(actionCreator(ClientLogAction.fetchDirectoryPath.REQUEST))
        fetch(`${BASE_URL}/mst/api/data/web/getLogDirectoryPath`, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(response => {
            if(!response.st) {
                if(response.responseCode && response.responseCode === "401") {
                    localStorage.setItem("tokenExpired", "true")
                    localStorage.removeItem('accessToken')
                    window.location.reload()
                }  else {
                    dispatch(actionCreator(ClientLogAction.fetchDirectoryPath.FAILURE, response))
                }
            } else {
                dispatch(actionCreator(ClientLogAction.fetchDirectoryPath.SUCCESS, response))
            }
        })
        .catch((error) => {
            console.log("error >>> ", error)
        })
    }
}

export function fetchLogLevel(payload) {
    return(dispatch, getState) => {
        const token = getState().AuthReducer.authResponse.authtoken
        dispatch(actionCreator(ClientLogAction.fetchLogLevel.REQUEST))
        fetch(`${BASE_URL}/mst/api/data/web/getLogLevels`, {
            method: 'GET',
            // body: JSON.stringify(payload),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(response => {
            if(!response.st) {
                if(response.responseCode && response.responseCode === "401") {
                    localStorage.setItem("tokenExpired", "true")
                    localStorage.removeItem('accessToken')
                    window.location.reload()
                }  else {
                    dispatch(actionCreator(ClientLogAction.fetchLogLevel.FAILURE, response))
                }
            } else {
                dispatch(actionCreator(ClientLogAction.fetchLogLevel.SUCCESS, response))
            }
        })
        .catch((error) => {
            console.log("error >>> ", error)
        })
    }
}

export function addOrEditClientLogMapping(payload) {
    return(dispatch, getState) => {
        const token = getState().AuthReducer.authResponse.authtoken
        dispatch(actionCreator(ClientLogAction.addOrEditClientLog.REQUEST))
        fetch(`${BASE_URL}/mst/api/data/web/addOrEditClientLogMapping`, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(response => {
            if(!response.st) {
                if(response.responseCode && response.responseCode === "401") {
                    localStorage.setItem("tokenExpired", "true")
                    localStorage.removeItem('accessToken')
                    window.location.reload()
                }  else {
                    dispatch(actionCreator(ClientLogAction.addOrEditClientLog.FAILURE, response))
                }
            } else {
                dispatch(actionCreator(ClientLogAction.addOrEditClientLog.SUCCESS, response))
            }
        })
        .catch((error) => {
            console.log("error >>> ", error)
        })
    }
}

export function resetCreateLogRes() {
    return(dispatch) => {
        dispatch(actionCreator(ClientLogAction.addOrEditClientLog.FAILURE, null))
    }
}

export function resetDirectoryPathRes() {
    return(dispatch) => {
        dispatch(actionCreator(ClientLogAction.fetchDirectoryPath.FAILURE, null))
    }
}